<div *ngIf="show">
    <span class="fa fa-spinner fa-pulse {{size}}" aria-hidden="true"></span> <span class="loader-text">{{text}}</span>
</div>